import { TeamPage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { usePageMeta } from "@/shared/seo/use-page-meta";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/nas-tym")({
  component: TeamRoute,
});

function TeamRoute() {
  usePageMeta({
    title: "Náš tým",
    description:
      "Lektoři, konzultanti a vedení HCA Moravia — lidé s praxí z byznysu, kteří vedou naše semináře, tréninky a rozvojové programy.",
    path: "/nas-tym",
  });
  return (
    <PublicShellWithDiagnoza>
      <TeamPage />
    </PublicShellWithDiagnoza>
  );
}
